import { useNavigate } from 'react-router-dom';
import Header from '../../Common/Header/Header';
import '../../Common/Common/Style.css'
import React, { useEffect, useState } from 'react';
import { deleteUnitByID, getAllUnitByOffset, getUnitByUnitId, searchUnit } from '../../../api/unit';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import Loader from '../../Common/FullscreenLoader/FullScreenLoader';
import SuccessPopup from '../../Common/MessagePopup/SuccessPopup';
import FailurePoup from '../../Common/MessagePopup/FailurePopup';
import DatePicker from 'react-datepicker';
import ConfirmationPopup from '../../Common/MessagePopup/ConfirmationPopup';
import { UnitSingleDataType, UnitTableDataType } from './UnitInterface';
import LottieAnimation from '../../Common/LottieAnimation/LottieAnimation';
import { getNewAccessToken } from '../../../api/auth';
import { setToken } from '../../../reducers/UserSplice';
import { getGrade } from '../../../api/tribe';
import { setSubMenuActiveTab } from '../../../reducers/tabSplice';
import { IdAndName, LoadingDataType, MessageDataType } from '../../Common/Common/CommonInterface';
import { Tooltip } from "react-tooltip";
import { updateUnit } from '../../../api/lesson';
import CustomAlert from '../../Common/MessagePopup/CustomeAlert';
import FullScreenImagePreview from '../../Common/LottieAnimation/FullScreenImagePreview';

const Unit = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()


  const [showUnitPopup, setShowUnitPopup] = useState<boolean>(false);
  const [unitIdData, setUnitIdData] = useState<IdAndName>({
    id: "",
    name: ""
  });

  const [dropDownList, setDropDownList] = useState<{ grade: IdAndName[] }>({
    grade: []
  })
  const [validated, setValidated] = useState(false);
  const [confirmationPopupData, setConfirmationPopupData] = useState({
    title: "",
    message: "",
    descriptions: "",
    acceptText: "",
    cancelText: "",
    onAccept: () => { },
    onCancel: () => { },
  });

  

  const [previewSource, setPreviewSource] = useState<string>("");

  const handleOpenMedia = (file: any) => {

    if (file instanceof File) {

      const objectURL = URL.createObjectURL(file);
      setPreviewSource(objectURL);
    } else {

      setPreviewSource(file);
    }
  };


  const checkFileLimit = (file: File): boolean => {

    switch (file.type) {
      case "video/mp4":
      case "video/webm":
        return file.size <= 250 * 1024 * 1024; // 250 MB

      case "audio/wav":
      case "audio/mpeg": // standard MIME for mp3
        return file.size <= 20 * 1024 * 1024; // 20 MB

      case "image/png":
      case "image/jpeg": // covers both jpg & jpeg
      case "application/json":
      case "image/svg+xml":
        return file.size <= 20 * 1024 * 1024; // 20 MB

      default:
        // fallback (100 MB limit)
        return file.size <= 100 * 1024 * 1024;
    }
  };




  const handleClosePreview = () => {
    setPreviewSource("");
  };

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  const { access_token, refresh_token } = useAppSelector((state) => state.user.token)
  const [activeFilter, setActiveFilter] = useState<{ status: string, grade: IdAndName }>({
    status: "",
    grade: { id: "", name: "" },
  })

  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [searchtext, setSearchText] = useState<string>('');
  const [unitTableData, setUnitTableData] = useState<UnitTableDataType[]>([])
  const [unitData, setUnitData] = useState<UnitSingleDataType>({
    id: "",
    unitName: "",
    unitTribe: { id: "", name: "" },
    unitSubject: { id: "", name: "" },
    unitGrade: { id: "", name: "" },
    deleteS3Path: [],
    unitLesson: { id: "", name: "" },
    unitLevel: 0,
    unitMedia: {
      DesktopBanner: {
        files: "",
        blobPath: "",
        fileExtension: ""
      },
      MobileBanner: {
        files: "",
        blobPath: "",
        fileExtension: ""
      },
      BadgeIcon: {
        files: "",
        blobPath: "",
        fileExtension: ""
      },
    },
    unitReward: 0,
    unitStatus: ""
  })

  const handleEndDateChange = (date: any) => {
    const currentDate = new Date(); // Get the current date

    if (!startDate) {
      setMessage({
        ...message,
        errorMessage: [
          "Please select a start date before choosing the end date.",
        ],
      });
      return;
    }

    if (date < startDate) {
      setMessage({
        ...message,
        errorMessage: [
          "The end date cannot be earlier than the start date. Please choose a valid end date.",
        ],
      });
      return;
    }

    if (date > currentDate) {
      setMessage({
        ...message,
        errorMessage: [
          "The end date cannot be in the future. Please select a date that is today or earlier.",
        ],
      });
      return;
    }

    setEndDate(date);
  };


  const handleCancel = () => {
    setShow(true);
    setConfirmationPopupData({
      title: "Are you sure you want to cancel?",
      message: "This action will not be undo",
      descriptions: "",
      acceptText: "Ok",
      cancelText: "Cancel",
      onAccept: async () => {
        setShow(false)
        setValidated(false);
        setUnitIdData({
          id: "",
          name: ""
        })
        setUnitData({
          id: "",
          unitName: "",
          deleteS3Path: [],
          unitTribe: { id: "", name: "" },
          unitSubject: { id: "", name: "" },
          unitGrade: { id: "", name: "" },
          unitLesson: { id: "", name: "" },
          unitLevel: 0,
          unitMedia: {
            DesktopBanner: {
              files: "",
              blobPath: "",
              fileExtension: ""
            },
            MobileBanner: {
              files: "",
              blobPath: "",
              fileExtension: ""
            },
            BadgeIcon: {
              files: "",
              blobPath: "",
              fileExtension: ""
            },
          },
          unitReward: 0,
          unitStatus: ""
        })
        getUnit(indexOfFirstItem);

        setShowUnitPopup(false);

      },
      onCancel: handleClose
    })

  }

  const [filter, setFilter] = useState<{ status: string, dateFilter: string, grade: string }>({ status: "", dateFilter: "", grade: "" })

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [unitCount, setUnitCount] = useState<number>(0);
  const [loading, setLoading] = useState<LoadingDataType>({
    fetchingLoading: false,
    tableLoading: false,
    deleteLoading: false,
    submitLoading: false,
    validationLoading: false,

  });

  const [message, setMessage] = useState<MessageDataType>({
    errorMessage: [],
    successMessage: "",
    failureMessage: ""
  })
  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    useEffect(() => {
      if (message.errorMessage.length > 0) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
  
    }, [message.errorMessage.length])

  const getAuthorizedToken = async () => {
    try {
      await getNewAccessToken({ refreshToken: refresh_token }).then((newTokenResponse) => {
        const { data, statusCode } = newTokenResponse;
        if (statusCode === 200) {
          dispatch(setToken({
            access_token: data.accessToken,
            refresh_token: data.refreshToken
          }))
        }
      })
    } catch (error: any) {
      console.error("Something went wrong in getting new access Token :: ", error)
    }
  }

  const handlePagination = async (pageNumber: number, direction: string) => {
    try {
      if (pageNumber < 1 || pageNumber > Math.ceil(unitCount / itemsPerPage)) {
        return; // Prevent navigation to invalid pages
      }

      setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, validationLoading: false, }))

      if (direction === "right") {
        if (pageNumber <= Math.ceil(unitCount / itemsPerPage)) {
          setCurrentPage(pageNumber);
        }
      } else {
        if (pageNumber >= 1) {
          setCurrentPage(pageNumber);
        }
      }

    } finally {
      setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
    }

  };

  const formatLocalDate = (date: Date | null): string | null => {
    if (!date) return null; // Handle null case

    const localDate = new Date(date);
    localDate.setMinutes(localDate.getMinutes() - localDate.getTimezoneOffset()); // Adjust for timezone shift

    return localDate.toISOString().split("T")[0]; // Extract YYYY-MM-DD
  };


  const handleFilter = (name: string, value: string | IdAndName) => {
    if (name === "status" && typeof value === "string") {
      setActiveFilter(prev => ({
        ...prev,
        status: value ? value : ""
      }));

      setFilter(prev => ({
        ...prev,
        status: value === "1" ? "Published" : value === "2" ? "Draft" : value === "0" ? "Unpublished" : ""
      }));
    } else if (name === "grade" && typeof value === "object") {
      setActiveFilter(prev => ({
        ...prev,
        grade: value
      }));

      setFilter(prev => ({
        ...prev,
        grade: value.name
      }));
    } else if (name === "date") {
      setFilter({
        ...filter,
        dateFilter: ""
      })
      setStartDate(null)
      setEndDate(null)
    }
  };


  useEffect(() => {
    const handleSearch = async () => {
      setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, validationLoading: false, }))
      setCurrentPage(1);
      if (startDate && endDate) {
        const lang = navigator.language || navigator.languages[0];
        setFilter({
          ...filter,
          dateFilter: `${startDate ? startDate.toLocaleDateString(lang, { day: "numeric", month: "short", year: "numeric" }) : ""} - ${endDate ? endDate.toLocaleDateString(lang, { day: "numeric", month: "short", year: "numeric" }) : ""
            }`
        });
      }
      try {
        const searchTribeData = await searchUnit(searchtext, activeFilter.status, activeFilter.grade.id, (startDate && endDate) ? formatLocalDate(startDate) : null, (startDate && endDate) ? formatLocalDate(endDate) : null, String(indexOfFirstItem), String(indexOfLastItem), "", access_token);

        const { data, statusCode } = searchTribeData;

        if (statusCode === 200) {
          handleUnitData(data);
        } else if (statusCode === 401) {
          getAuthorizedToken();
          setMessage({
            ...message,
            failureMessage: "Authorization token expired. Try again!"
          })
        }
      } catch (error: any) {
        console.error("Search Error ::", error);
        if (error.response && error.response.data && typeof error.response.data === "string") {
          setMessage({
            ...message,
            failureMessage: error.response.data.message
          })
        } else {
          setMessage({
            ...message,
            failureMessage: "Something went wrong. Please try again"
          })
        }
      } finally {
        setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
      }
    }

    handleSearch()

  }, [searchtext, activeFilter.status, activeFilter.grade.id, startDate, endDate])





  const getUnit = async (offset: number) => {
    setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, validationLoading: false, }))
    try {
      await getAllUnitByOffset(String(offset), String(itemsPerPage), false, access_token).then((allLessonResponse: any) => {
        const { data, statusCode } = allLessonResponse;
        if (statusCode === 200) {
          handleUnitData(data);
        } else {
          getUnit(indexOfFirstItem);
        }
      })
    } catch (error: any) {
      console.error('Error fetching tribe data:', error);
      if (error.response && error.response.data && typeof error.response.data === "string") {
        setMessage({
          ...message,
          failureMessage: error.response.data.message
        })
      } else {
        setMessage({
          ...message,
          failureMessage: "Something went wrong. Please try again"
        })
      }
    } finally {
      setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
    }
  };


  const handleUnitData = (unitTableData: any) => {
    const { units, count } = unitTableData;
    setUnitCount(count)
    let formattedData: UnitTableDataType[] = units.map((unit: any) => {
      if (unit.lesson.tribe_id) {
        return {
          id: unit.id,
          name: unit.name,
          grade: { gradeId: unit.lesson.grade_id.id, gradeName: unit.lesson.grade_id.name },
          lesson: unit.lesson.name,
          subject: unit.lesson.subject_id.name,
          tribe: unit.lesson.tribe_id.name,
          status: unit.isActive === 1 ? "PUBLISHED" : (unit.isActive === 2 ? "DRAFT" : "UNPUBLISHED"),
        };
      }

      return null;

    }).filter((item: any) => item !== null); // remove null values if needed
    setUnitTableData(formattedData); // Set the formatted data
  }



  const handleUnitMedia = (e: any, objectNames: string, s3path: string, file: any, label: string) => {
    if (label === "delete") {
      setShow(true);
      let objName = ""
      if (objectNames === "desktop") {
        objName = "Unit Banner"
      } else if (objectNames === "badge") {
        objName = "Unit Badge"
      }
      setConfirmationPopupData({
        title: `Are you sure you want to delete ${objName}?`,
        message: "This action cannot be undone.",
        descriptions: "",
        acceptText: "Delete",
        cancelText: "Cancel",
        onAccept: () => {
          setShow(false)
          if (s3path === file) {

            setUnitData((prev) => {
              const updatedData = { ...prev };
              updatedData.deleteS3Path = [...updatedData.deleteS3Path, s3path]
              if (objectNames === "badge") {
                updatedData.unitMedia.BadgeIcon = { files: "", blobPath: "", fileExtension: "" }

              } else if (objectNames === "desktop") {
                updatedData.unitMedia.DesktopBanner = { files: "", blobPath: "", fileExtension: "" }
              }


              return updatedData;
            })

          } else {
            setUnitData((prev) => {
              const updatedData = { ...prev };
              if (objectNames === "badge") {
                updatedData.unitMedia.BadgeIcon = { files: "", blobPath: "", fileExtension: "" }

              } else if (objectNames === "desktop") {
                updatedData.unitMedia.DesktopBanner = { files: "", blobPath: "", fileExtension: "" }
              }


              return updatedData;
            })
          }
        },
        onCancel: handleClose,
      })
    } else if (label === "add") {
      const { files } = e.target;

      const file = files?.[0];
      const extension = file?.name.split('.').pop()?.toLowerCase() || '';

      if (!file) {
        return;
      }

      // First, update `deleteS3Path`
      setUnitData((prev) => ({
        ...prev,
        deleteS3Path: [...prev.deleteS3Path, s3path],
      }));

      if (objectNames === 'badge') {
        if (file && (file.name.toLowerCase().endsWith('.png') || file.name.toLowerCase().endsWith('.jpg') || file.name.toLowerCase().endsWith('.jpeg') || file.name.toLowerCase().endsWith('.svg'))) {
          if (checkFileLimit(file)) {
            setUnitData((prev) => ({
              ...prev,
              unitMedia: {
                ...prev.unitMedia,
                BadgeIcon: {
                  files: file,
                  blobPath: URL.createObjectURL(file),
                  fileExtension: extension,
                },
              },
            }));

          } else {
            setMessage({
              ...message,
              errorMessage: ['File Size Exceed. Try to upload within the size limit.']
            });
            return;
          }


        } else {
          setMessage({
            ...message,
            errorMessage: ['Unsupported image format. Please upload JPG, PNG, SVG or JPEG files.'],
          });
        }
      } else if (objectNames === 'desktop') {
        if (file && (file.name.toLowerCase().endsWith('.png') || file.name.toLowerCase().endsWith('.jpg') || file.name.toLowerCase().endsWith('.jpeg') || file.name.toLowerCase().endsWith('.svg'))) {
          if (checkFileLimit(file)) {
            setUnitData((prev) => ({
              ...prev,
              deleteS3Path: [...prev.deleteS3Path, s3path],
              unitMedia: {
                ...prev.unitMedia,
                DesktopBanner: {
                  files: file,
                  blobPath: URL.createObjectURL(file),
                  fileExtension: extension,
                },
              },
            }));

          } else {
            setMessage({
              ...message,
              errorMessage: ['File Size Exceed. Try to upload within the size limit.']
            });
            return;
          }


        } else {
          setMessage({
            ...message,
            errorMessage: ['Unsupported image format. Please upload JPG, PNG, , SVG or JPEG files.'],
          });
        }
      }


    }

  };

  const handleUnitInput = (e: React.ChangeEvent<HTMLInputElement> | any) => {
    const { name, value } = e.target;
    setUnitData({
      ...unitData,
      [name]: value
    })

  }


  const getAllGrade = async () => {
    const gradeResponse = await getGrade();

    setDropDownList({
      grade: gradeResponse.data.data.map((grade: any) => ({
        id: grade.id,
        name: grade.name
      }))
    })

  }



  useEffect(() => {

    getUnit(indexOfFirstItem);

    getAllGrade();
  }, []);



  useEffect(() => {
    const fetchData = async () => {
      if (activeFilter.status || activeFilter.grade.id || searchtext || startDate || endDate) {
        try {
          await searchUnit(searchtext, activeFilter.status, activeFilter.grade.id, formatLocalDate(startDate), formatLocalDate(endDate), String(indexOfFirstItem), String(indexOfLastItem), "", access_token).then((searchTribeData) => {
            const { data, statusCode } = searchTribeData;
            if (statusCode === 200) {
              handleUnitData(data);
            } else if (statusCode === 401) {
              getAuthorizedToken();
              setMessage({
                ...message,
                failureMessage: "Authorization token expired. Try again!"
              })
            }
          });

        } catch (error: any) {
          console.error("Error fetching tribe data:", error);
          if (error.response && error.response.data && typeof error.response.data === "string") {
            setMessage({
              ...message,
              failureMessage: error.response.data.message
            })
          } else {
            setMessage({
              ...message,
              failureMessage: "Something went wrong. Please try again"
            })
          }
        }
      } else {
        getUnit(indexOfFirstItem);

      }
    };

    fetchData();
  }, [currentPage]);



  const handleDeleteUnit = async (unit: UnitTableDataType) => {

    setShow(true)
    setConfirmationPopupData({
      title: `Are you sure you want to delete ${unit.name} unit?`,
      message: "This action cannot be undone.",
      descriptions: "",
      acceptText: "Delete",
      cancelText: "Cancel",
      onAccept: async () => {
        setShow(false)
        setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: true, submitLoading: false, validationLoading: false, }))
        try {
          await deleteUnitByID(unit.id, access_token).then((deleteUnitResponse) => {
            const { statusCode } = deleteUnitResponse;
            if (statusCode === 200) {
              setMessage({
                ...message,
                successMessage: "Unit deleted successfully!"
              })
            } else if (statusCode === 401) {
              getAuthorizedToken();
              setMessage({
                ...message,
                failureMessage: "Authorization token expired. Try again!"
              })
            }
          })
        } catch (error: any) {
          console.error("Error while fetching unit data :: ", error)
          if (error.response && error.response.data && typeof error.response.data === "string") {
            setMessage({
              ...message,
              failureMessage: error.response.data.message
            })
          } else {
            setMessage({
              ...message,
              failureMessage: "Something went wrong. Please try again"
            })
          }

        } finally {
          setTimeout(() => {
            setMessage({
              ...message,
              successMessage: "",
              failureMessage: ""
            })
          }, 2500)
          setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
          getUnit(indexOfFirstItem);

        }
      },
      onCancel: handleClose,
    })
  };


  const getUnitById = async (unitId: string) => {
    try {
      setLoading(prev => ({ ...prev, fetchingLoading: true, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))



      await getUnitByUnitId(unitId, access_token).then((getUnitResponse) => {
        const { data, statusCode } = getUnitResponse;
        if (statusCode === 200) {
          const getFileExtension = (path: string) => path ? path.split('.').pop() : "";

          const getMediaObject = (path: string) => ({
            files: path ? (data.id ? `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${path}` : path) : "",
            blobPath: path ? (data.id ? `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${path}` : path) : "",
            fileExtension: getFileExtension(path),
          });
          try {
            setUnitData({
              id: data.id,
              unitName: data.name,
              deleteS3Path: [],
              unitTribe: { id: data.lesson.tribe_id.id, name: data.lesson.tribe_id.name },
              unitSubject: { id: data.lesson.subject_id.id, name: data.lesson.subject_id.name },
              unitGrade: { id: data.lesson.grade_id.id, name: data.lesson.grade_id.name },
              unitLesson: { id: data.lesson.id, name: data.lesson.name },
              unitLevel: data.level,
              unitMedia: {
                DesktopBanner: getMediaObject(data.bannerImage_path_desk ? data.bannerImage_path_desk : ""),
                MobileBanner: getMediaObject(data.bannerImage_path_mobile ? data.bannerImage_path_mobile : ""),
                BadgeIcon: getMediaObject(data.badge_image ? data.badge_image : "")
              },
              unitReward: Number(data.reward),
              unitStatus: String(data.isActive)
            })
          } finally {
            setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
          }

        }

      })
    } catch (error: any) {
      if (error.response && error.response.data && typeof error.response.data === "string") {
        setMessage({
          ...message,
          failureMessage: error.response.data.message
        })
      } else {
        setMessage({
          ...message,
          failureMessage: "Something went wrong. Please try again"
        })
      }
    } finally {
      setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
      setMessage((prev => {
        const updatedData = { ...prev };
        updatedData.errorMessage = [];
        updatedData.failureMessage = "";
        updatedData.successMessage = ""
        return updatedData
      }))
    }
  }

  const handleEditBtn = async (unit: UnitTableDataType) => {

    setShowUnitPopup(true);
    setUnitIdData({
      id: unit.id,
      name: unit.name
    });
    setFilter({ status: "", dateFilter: "", grade: "" });
    setStartDate(null);
    setEndDate(null);

    getUnitById(unit.id)
  }



  const handleViewQuestionBtn = (unitId: string, unitName: string, gradeId: string) => {
    setShow(true);
    setConfirmationPopupData({
      title: `Are you sure you want to proceed to the new section?`,
      message: "Save edited unit data before proceeding.",
      descriptions: "",
      acceptText: "Proceed",
      cancelText: "Cancel",
      onAccept: async () => {
        setShow(false)
        dispatch(setSubMenuActiveTab('question'));
        navigate('/unit/questions', { state: { id: unitId, name: unitName, grade: gradeId } })
      },
      onCancel: handleClose,
    })


  };

  const validateForm = async () => {
    const { unitName, unitMedia, unitStatus } = unitData;
    let errorMessage: string[] = [];

    // Helper function for validating media files
    const isMediaValid = (media: any) => media && media.files;

    const hasStatus = !!unitStatus;
    const hasName = !!unitName?.trim();
    const hasDesktopBanner = isMediaValid(unitMedia.DesktopBanner);

    // Collect missing fields if any of them exists
    if (hasName || hasStatus || hasDesktopBanner) {
      const missing: string[] = [];
      if (!hasName) missing.push("Unit Name")
      if (!hasDesktopBanner) missing.push("Desktop banner image");
      if (!hasStatus) missing.push("Status");

      if (missing.length > 0) {
        errorMessage.push(`${missing.join(", ")} ${missing.length > 1 ? "are" : "is"} required.`);
      }
    }

    if (errorMessage.length > 0) {
      setValidated(true);
      setMessage({
        ...message,
        errorMessage: errorMessage
      });
    } else {
      handleSubmit();
    }
  };



  const handleSubmit = async () => {
    setShow(true)
    setConfirmationPopupData({
      title: "Are you sure you want to submit?",
      message: "This will submit the lesson data to the server.",
      descriptions: "",
      acceptText: "Submit",
      cancelText: "Cancel",
      onAccept: async () => {
        setShow(false)

        const formData = new FormData();
        formData.append("name", unitData.unitName);
        formData.append("tribe_id", unitData.unitTribe.id);
        formData.append("reward", String(0));
        // formData.append("active", unitData.unitStatus);

        formData.append('id', unitData.id);

        if (unitData.unitMedia.BadgeIcon.files instanceof File) {
          formData.append("badgeIcon", unitData.unitMedia.BadgeIcon.files);

        }
        if (unitData.unitMedia.DesktopBanner.files instanceof File) {
          formData.append("bannerImage_desk", unitData.unitMedia.DesktopBanner.files);
          formData.append("bannerImage_mobile", unitData.unitMedia.DesktopBanner.files);
        }

        if (unitData.deleteS3Path.length > 0) {
          formData.append("removeFiles", JSON.stringify(unitData.deleteS3Path.filter((s3path: string) => s3path.trim() !== "").map((s3path: string) => ({ path: s3path }))));
        }


        try {
          setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: true, validationLoading: false, }))
          await updateUnit(formData, access_token).then((updateLessonResponse) => {
            const { statusCode } = updateLessonResponse;
            if (statusCode === 200) {
              setShowUnitPopup(false)
              setMessage({
                ...message,
                successMessage: "Unit updated successfully!"
              });
            } else if (statusCode === 401) {
              getAuthorizedToken();
              setMessage({
                ...message,
                failureMessage: "Authorization token expired. Try again!"
              })
            }
          })
        } catch (error: any) {
          if (error.response && error.response.data && typeof error.response.data === "string") {
            setMessage({
              ...message,
              failureMessage: error.response.data.message
            })
          } else {
            setMessage({
              ...message,
              failureMessage: "Something went wrong. Please try again"
            })
          }
        } finally {
          setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, validationLoading: false, }))
          setTimeout(() => {

            setUnitData({
              ...unitData,
              deleteS3Path: [],
              unitMedia: {
                DesktopBanner: { files: "", blobPath: "", fileExtension: "" },
                MobileBanner: { files: "", blobPath: "", fileExtension: "" },
                BadgeIcon: { files: "", blobPath: "", fileExtension: "" },
              },
              unitReward: 0,
              unitStatus: ""
            })
            setMessage((prev => {
              const updatedData = { ...prev };
              updatedData.errorMessage = [];
              updatedData.failureMessage = "";
              updatedData.successMessage = ""
              return updatedData
            }))

          }, 2500)

          getUnit(indexOfFirstItem);
        }


      },
      onCancel: handleClose
    })

  }


  return (
    <div className="dashboard d-flex">
      <Header />
      <div className="rightContainer">
        {message.successMessage && <SuccessPopup message={message.successMessage} />}
        {message.failureMessage && <FailurePoup message={message.failureMessage} />}
        {!showUnitPopup ?
          <div>
            <div className="header-container">
              <h2 className="page-title text-center">Units</h2>
            </div>
            <div className="pCard">
              <div className="topAction align-items-center">
                <div className="dropdown statusDrop">
                  <button className="dropdown-toggle" type="button" id="dropdownMenuButtonStatus" data-bs-toggle="dropdown" aria-expanded="false">
                    {/* {activeFilter.status === "All" ? "Status" : activeFilter.status === "1" ? "Publish" : activeFilter.status === "0" ? "Inactive" : "Status"} */}
                    Status
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="dropdownMenuButtonStatus">
                    <li><button className={`dropdown-item`} name="status" onClick={() => handleFilter("status", "")}>All</button></li>
                    <li><button className={`dropdown-item ${activeFilter.status === "1" ? "active" : ""}`} name="status" value="Published" onClick={() => handleFilter("status", "1")} >Published</button></li>
                    <li><button className={`dropdown-item ${activeFilter.status === "2" ? "active" : ""}`} onClick={() => handleFilter("status", "2")}>Draft</button></li>
                    <li><button className={`dropdown-item ${activeFilter.status === "0" ? "active" : ""}`} name="status" value="Unpublished" onClick={() => handleFilter("status", "0")} >Unpublished</button></li>
                  </ul>

                  {filter.status &&
                    <span className="badge rounded-pill" style={{ marginLeft: '1rem', background: '#782ACB' }}>{filter.status}
                      <span className='ps-2' style={{ cursor: 'pointer' }}><img src="./assets/images/xmark-solid.svg" alt="" onClick={() => handleFilter("status", "")} /></span></span>
                  }

                  <button className="dropdown-toggle" type="button" id="dropdownMenuButtonGrade" data-bs-toggle="dropdown" aria-expanded="false" style={{ paddingLeft: "2rem" }}>
                    {/* {activeFilter.grade.id ? activeFilter.grade.name : "Grade"} */}
                    Grade
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="dropdownMenuButtonGrade">
                    <button className={`dropdown-item`} name="grade" value="showAllGrade" onClick={() => handleFilter("grade", { id: "", name: "" })} >
                      All
                    </button>
                    {dropDownList.grade.map((grade: IdAndName, index: number) => (
                      <li key={grade.id}>
                        <button className={`dropdown-item ${activeFilter.grade.id === grade.id ? "active" : ""}`} name="grade" value={grade.name} onClick={() => handleFilter("grade", { id: grade.id, name: grade.name })} >
                          {grade.name}
                        </button>
                      </li>
                    ))}
                  </ul>



                  {filter.grade &&
                    <span className="badge rounded-pill" style={{ marginLeft: '1rem', background: '#782ACB' }}>{filter.grade}
                      <span className='ps-2' style={{ cursor: 'pointer' }}><img src="./assets/images/xmark-solid.svg" alt="" onClick={() => handleFilter("grade", { id: "", name: "" })} /></span></span>
                  }


                  {filter.dateFilter &&
                    <span className="badge rounded-pill" style={{ marginLeft: '1rem', background: '#782ACB' }}>{filter.dateFilter}
                      <span className='ps-2' style={{ cursor: 'pointer' }}><img src="./assets/images/xmark-solid.svg" alt="" onClick={() => handleFilter("date", "")} /></span></span>
                  }
                </div>

                <div className="dropdown filter ms-auto">
                  <a className="dropdown-toggle" href="#blank" role="button" data-bs-toggle="dropdown" aria-expanded="false" >
                    <img src="./assets/images/filter.svg" alt="Filter" />
                  </a>
                  <div className="dropdown-menu p-3" onClick={(e) => e.stopPropagation()}>
                    <div className="mb-3">
                      {/* <label htmlFor="startDate" className="form-label">
                        Start Date
                      </label> */}
                      <DatePicker id="startDate" selected={startDate} onChange={(date) => setStartDate(date)} className="form-control" placeholderText="Date From" />
                    </div>
                    <div className="mb-3">
                      {/* <label htmlFor="endDate" className="form-label">
                        End Date
                      </label> */}
                      <DatePicker id="endDate" selected={endDate} onChange={handleEndDateChange} className="form-control" placeholderText="Date To" />
                    </div>
                  </div>
                </div>
                <div className="searchInputDashboard">
                  <input type="text" placeholder="Search" name="searchText" value={searchtext} onChange={(e) => setSearchText(e.target.value)} />
                </div>


              </div>
              {loading.tableLoading ? ( // Show loader when loading is true
                <div className="d-flex align-items-center mt-5">
                  <div className="loader mx-auto"></div>
                </div>
              ) :
                unitTableData.length > 0 ?
                  <div className="table-responsive">
                    <table className="table table-bordered" id="table_with_lessons_data">
                      <thead>
                        <tr>
                          <th className="text-start">UNIT</th>
                          <th className="text-center">GRADE</th>
                          <th className="text-center">LESSON</th>
                          <th className="text-center">SUBJECT</th>
                          <th className="text-center">TRIBE</th>
                          <th className="text-center">STATUS</th>


                          <th className='text-center'>ACTION</th>
                        </tr>
                      </thead>
                      <tbody>
                        {unitTableData.map((unit: UnitTableDataType) => (
                          <tr key={unit.id} id={unit.id}>
                            {/* Unit with Tooltip */}
                            <td className="text-start">
                              <span data-tooltip-id={`unit-tooltip-${unit.id}`} data-tooltip-content={unit.name} data-tooltip-place="top" >
                                {unit.name.length > 10 ? unit.name.substring(0, 10) + "..." : unit.name}
                              </span>
                              {unit.name.length > 10 && <Tooltip id={`unit-tooltip-${unit.id}`} />}
                            </td>

                            <td className="text-center">
                              {unit.grade.gradeId === "1" ? unit.grade.gradeName.substring(0, 6) : unit.grade.gradeName.substring(0, 7)}
                            </td>

                            {/* Lesson with Tooltip */}
                            <td className="text-center">
                              <span data-tooltip-id={`lesson-tooltip-${unit.id}`} data-tooltip-content={unit.lesson} data-tooltip-place="top" >
                                {unit.lesson.length > 10 ? unit.lesson.substring(0, 10) + "..." : unit.lesson}
                              </span>
                              {unit.lesson.length > 10 && <Tooltip id={`lesson-tooltip-${unit.id}`} />}
                            </td>

                            {/* Subject with Tooltip */}
                            <td className="text-center">
                              <span data-tooltip-id={`subject-tooltip-${unit.id}`} data-tooltip-content={unit.subject} data-tooltip-place="top" >
                                {unit.subject.length > 10 ? unit.subject.substring(0, 10) + "..." : unit.subject}
                              </span>
                              {unit.subject.length > 10 && <Tooltip id={`subject-tooltip-${unit.id}`} />}
                            </td>

                            {/* Tribe with Tooltip */}
                            <td className="text-center">
                              <span data-tooltip-id={`tribe-tooltip-${unit.id}`} data-tooltip-content={unit.tribe} data-tooltip-place="top" >
                                {unit.tribe.length > 10 ? unit.tribe.substring(0, 10) + "..." : unit.tribe}
                              </span>
                              {unit.tribe.length > 10 && <Tooltip id={`tribe-tooltip-${unit.id}`} />}
                            </td>

                            <td className="text-center">
                              <span className={unit.status === "PUBLISHED" ? "activeStatus" : (unit.status === "DRAFT" ? "draftStatus" : "inactiveStatus")}>
                                {unit.status}
                              </span>
                            </td>

                            <td className="text-center">
                              <div className="dropdown dots">
                                <button className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                  <img src='./assets/images/more.svg' alt='action button'/>
                                </button>
                                <ul className="dropdown-menu">
                                  <li>
                                    <button className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => handleEditBtn(unit)}>
                                      <img src="assets/images/edit-icon.png" alt="" className="me-2" />
                                      Edit
                                    </button>
                                  </li>
                                  <li>
                                    <button className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => handleDeleteUnit(unit)}>
                                      <img src="assets/images/delete.png" alt="" className="me-2" />
                                      Delete
                                    </button>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  :
                  <p className="text-center mt-5">No Data Found</p>
              }
              {/* Pagination Controls */}
              <div className="pagination-container">

                <nav className='d-flex justify-content-between'>
                  <div className='page-length'>
                    Showing {Math.min(indexOfFirstItem + 1, unitCount)} - {Math.min(indexOfLastItem, unitCount)} of {unitCount}
                  </div>
                  <ul className="pagination justify-content-center mx-auto">
                    <li className="page-item">
                      <button className="page-link" onClick={() => handlePagination(currentPage - 1, "left")} aria-label="Previous">
                        <span aria-hidden="true"><img src="assets/images/arrow-left-small.svg" alt="" /></span>
                      </button>
                    </li>
                    <li className="page-item disabled">
                      <span className="page-link">
                        {indexOfFirstItem + 1} of {indexOfLastItem}
                      </span>
                    </li>
                    <li className="page-item">
                      <button className="page-link" onClick={() => handlePagination(currentPage + 1, "right")} aria-label="Next" >
                        <span aria-hidden="true"><img src="assets/images/arrow-right-small.svg" alt="" /></span>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
          :
          <div>
            <h2 className="main-title text-center page-title">{unitIdData.name}</h2>
            <div className="pCard" style={{ backgroundColor: "#ffffff" }}>
              <h5 className="form-title">Description</h5>
              <div className="row">

                <div className="col">
                  <div className="form-group">
                    <h6 className='highlightMediaText'>Lesson</h6>
                    <input type="text" name="unitlesson" className="form-control lightHightlightText" placeholder="Unit Lesson" value={unitData.unitLesson.name} readOnly />
                  </div>
                </div>


                <div className="col">
                  <div className="form-group">
                    <h6 className='highlightMediaText'>Subject</h6>
                    <input type="text" name="unitSubject" className="form-control lightHightlightText" placeholder="Unit Subject" value={unitData.unitSubject.name} readOnly />
                  </div>
                </div>

                <div className="col">
                  <div className="form-group">
                    <h6 className='highlightMediaText'>Tribe</h6>
                    <input type="text" name="unitTribe" className="form-control lightHightlightText" placeholder="Unit Tribe" value={unitData.unitTribe.name} readOnly />
                  </div>
                </div>

                <div className="col">
                  <div className="form-group">
                    <h6 className='highlightMediaText'>Grade</h6>
                    <input type="text" name="lessonReward" className="form-control lightHightlightText" placeholder="Unit Grade" value={unitData.unitGrade.name} readOnly />
                  </div>
                </div>
              </div>

              <div className="form-group">
                <h6 className='highlightMediaText'>Unit Name <span className="text-danger">*</span></h6>
                <input type="text" name="unitName" className="form-control" placeholder="Unit Name" value={unitData.unitName} onChange={(e) => handleUnitInput(e)} required />
              </div>

              <div className="row">
                <div className="col-md-12">
                  <h6 className='highlightMediaText'>Banner <span className="text-danger">*</span></h6>
                  <div className="form-group">
                    <div className="customImgUpload">
                      <div className="uploadBtn">
                        {unitData.unitMedia.DesktopBanner.files ?
                          <div className="w-100">
                            <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                              <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                <img src={unitData.unitMedia.DesktopBanner.blobPath} alt="Preview" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenMedia(unitData.unitMedia.DesktopBanner.files)} />
                              </div>
                              {/* <button type="button" className="bg-transparent" onClick={(e) => handleUnitMedia(e, "desktop", unitData.unitMedia.DesktopBanner.blobPath, unitData.unitMedia.DesktopBanner.files, "delete")} >
                                <img src="./assets/images/delete.svg" alt="Delete" width="24" />
                              </button> */}
                            </div>
                          </div>
                          :
                          <>
                            <img className="noimage" src="./assets/images/no-image-icon.png" alt="" />
                            <label htmlFor="CustomDesktopBannerFile">
                              Click to upload <span>png, jpg, or jpeg <br />(max 20mb)</span>
                            </label>
                            <input type="file" className="form-control d-none" id="CustomDesktopBannerFile" name="desktop" accept=".png, .jpg, .jpeg" onChange={(e) => handleUnitMedia(e, "desktop", "", "", "add")} required />
                            <div className="invalid-feedback" style={{ textAlign: "center" }}>Please upload a unit banner.</div>
                          </>}
                      </div>
                    </div>
                  </div>
                  {unitData.unitMedia.DesktopBanner.files && <div className="row justify-content-center">
                    <div className="col-auto">
                      <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={(e) => handleUnitMedia(e, "desktop", unitData.unitMedia.DesktopBanner.blobPath, unitData.unitMedia.DesktopBanner.files, "delete")}>
                        <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                      </button>
                    </div>
                  </div>}
                </div>
              </div>



              <div className="form-group mt-3 mb-5">
                <div className="position-relative">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="m-0">Add new or view section</p>
                    <button className="btn" type="button" id="button-addon2" onClick={() => handleViewQuestionBtn(unitData.id, unitData.unitName, unitData.unitGrade.id)}><img src="./assets/images/add-icon.svg" alt="Add" /></button>
                  </div>
                </div>
              </div>



              <div className="form-actions">
                <div className="row">
                  <div className="col-md-3"></div>
                  <div className="col-md-3"></div>

                  <div className="col-md-3">
                    <div className="btn-group w-100">
                      <button type="button" className="btn btn-save btnPurple" onClick={validateForm}>Save</button>
                      {/* <button type="button" style={{ flex: '1 1 15%', border: "hidden" }} className="btn btnPurple dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
                        <span className="visually-hidden">Toggle Dropdown</span>
                      </button>
                      <ul className="dropdown-menu" style={{ background: '#E9E4FF', borderRadius: '20' }}>
                        <li><a className="dropdown-item" href="#">Publish</a></li>
                        <li><a className="dropdown-item" href="#">Save as draft</a></li>
                      </ul> */}
                    </div>
                  </div>
                  <div className="col-md-3">
                    <button type="button" className="btn btn-cancel btnBorder" onClick={handleCancel} >Back to Unit list</button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        }
      </div>
      {loading.fetchingLoading && (
        <Loader message="Loading, Fetching Data..." />
      )}
      {loading.deleteLoading && (
        <Loader message="Deleting Data..." />
      )}
      {loading.submitLoading && (
        <Loader message="Submitting Data..." />
      )}
      {message.errorMessage.length > 0 &&
        <CustomAlert
          errorCount={message.errorMessage.length}
          messages={message.errorMessage}
          onClose={() => { setValidated(false); setMessage({ ...message, errorMessage: [] }) }}
        />
      }
      {show &&
        <ConfirmationPopup
          title={confirmationPopupData.title}
          message={confirmationPopupData.message}
          isBackIterated={true}
          descriptions={confirmationPopupData.descriptions}
          acceptText={confirmationPopupData.acceptText}
          cancelText={confirmationPopupData.cancelText}
          onAccept={confirmationPopupData.onAccept}
          onCancel={confirmationPopupData.onCancel}
          onCrossClick={confirmationPopupData.onCancel}
        />
      }


      {previewSource && (
        <FullScreenImagePreview show={true} imagePath={previewSource} onClose={handleClosePreview} />
      )}
    </div>
  );
}

export default Unit